import React from 'react';

import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region META

const MetaTokens = (data) => [
    Token.getWrappedTokenConfig('Artist Name', Token.Artist.Name),
    Token.getWrappedTokenConfig('Title', Token.Inventory.Title),
    Token.getWrappedTokenConfig('Edition Info', Token.Inventory.Edition),
    Token.getWrappedTokenConfig('Created Date', Token.Date),
    Token.getWrappedTokenConfig('Medium', Token.Inventory.Medium),
    Token.getDimensionsTokenConfig('Dimensions', Token.Inventory.Dimensions),
    Token.getDimensionsTokenConfig('Alternate Dimensions', Token.Inventory.AlternateDimensions),
    Token.getWrappedTokenConfig('Framing', Token.Inventory.Framed),
    Token.getWrappedTokenConfig('Inventory Number', Token.Inventory.Number),
    Token.getWrappedTokenConfig('SKU', Token.Inventory.SKU),
    Token.getCurrencyTokenConfig('Price', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Price),
    Token.getCurrencyTokenConfig('Cost', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.Cost),
    Token.getCurrencyTokenConfig('Insurance Value', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Inventory.InsuranceValue),
    Token.getWrappedTokenConfig('Quantity', Token.Inventory.Quantity)
]

// #endregion META

// #region CONTAINER

const ContainerTypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "columnCount": "4",
                            "collapseIfEmpty-col1": false,
                            "alignmentHeader-col1": "tl",
                            "alignment-col1": "tl",
                            "width-col1": {
                                "unit": "%",
                                "value": "15"
                            },
                            "alignmentHeader-col2": "tl",
                            "alignment-col2": "tl",
                            "width-col2": {
                                "unit": "%",
                                "value": "35"
                            },
                            "alignmentHeader-col3": "tl",
                            "alignment-col3": "tl",
                            "width-col3": {
                                "unit": "%",
                                "value": "25"
                            },
                            "alignmentHeader-col4": "tl",
                            "alignment-col4": "tl",
                            "width-col4": {
                                "unit": "%",
                                "value": "25"
                            },
                            "alignmentHeader-col5": "tl",
                            "width-col5": {
                                "unit": "%",
                                "value": "25"
                            },
                            "alignmentHeader-col6": "tl",
                            "width-col6": {
                                "unit": "%",
                                "value": "25"
                            },
                            "paddingLeft-col3": {
                                "unit": "px",
                                "value": ""
                            },
                            "designHeader-col2": Utilities.wrapTextForEditor({ text: 'Inventory', textExtras: `style="font-weight:bold;"` }),
                            "designHeader-col3": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: 'Quantity', textExtras: `style="font-weight:bold;"` }),
                            "designHeader-col4": Utilities.wrapTextForEditor({ text: 'Price', textExtras: `style="font-weight:bold;"` }),
                            "renderHeaderOnlyFirst": true,
                            "spacing": {
                                "unit": "px",
                                "value": "10"
                            }
                        },
                        "Style": {}
                    },
                    "dataType": "layout",
                    "id": `${Name.Block.Columns}-${new Date().getTime()}`,
                    "type": {
                        "value": "columns"
                    },
                    "blocks": [
                        [
                            {
                                "config": {
                                    "Block": {},
                                    "Style": {
                                        "textAlign": "center"
                                    }
                                },
                                "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Image
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": `${Utilities.wrapTextForEditor({ text: `{${Token.Artist.Name}("before":"","after":"")}`, token: Token.Artist.Name })}<p class="p">${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Title}("before":"","after":"")}`, textExtras: `style="display:inline;font-style:italic;"`, token: Token.Inventory.Title, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Edition}("before":" (","after":")")}`, textExtras: `style="display:inline;"`, token: Token.Inventory.Edition, wrapWithTag: false })}${Utilities.wrapTextForEditor({ text: `{${Token.Date}("before":", ","after":"")}`, textExtras: `style="display:inline;"`, token: Token.Date, wrapWithTag: false })}</p>${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Medium}("before":"","after":"")}`, token: Token.Inventory.Medium })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Dimensions}("before":"","after":"")}`, token: Token.Inventory.Dimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.AlternateDimensions}("before":"","after":"")}`, token: Token.Inventory.AlternateDimensions })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.SKU}("before":"SKU: ","after":"")}`, token: Token.Inventory.SKU })}${Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Number}("before":"Inventory #: ","after":"")}`, token: Token.Inventory.Number })}`
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ tagExtras: `style="text-align:center;"`, text: `{${Token.Inventory.Quantity}("before":"","after":"")}`, token: Token.Inventory.Quantity })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ],
                        [
                            {
                                "config": {
                                    "Block": {
                                        "design": Utilities.wrapTextForEditor({ text: `{${Token.Inventory.Price}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Inventory.Price })
                                    },
                                    "Style": {}
                                },
                                "id": `${Name.Block.Inventory.Meta}-3-${new Date().getTime()}`,
                                "type": {
                                    "value": Name.Block.Inventory.Meta
                                }
                            }
                        ]
                    ]
                }
            ]
        },
        "Type": Name.Content.PurchaseOrderLineItem
    })
}

// #endregion CONTAINER

export {
    ContainerTypeConfig,
    MetaTokens
};